import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import { useTheme } from 'styled-components';

const Button = ({
  disabled,
  children,
  variant,
  handleClick,
  type,
  ...rest
}) => {
  const [Skin, setSkin] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    async function getSkin() {
      const response = await import(`./skins/${theme.components.button.skin}/`);

      setSkin(() => response.default);
    }

    getSkin();
  }, [theme]);

  return (
    Skin && (
      <Skin
        {...rest}
        disabled={disabled}
        variant={variant}
        handleClick={handleClick}
        type={type}
      >
        {children}
      </Skin>
    )
  );
};

Button.defaultProps = {
  variant: 'primary',
  type: 'button',
  disabled: false,
  handleClick: () => {},
};

Button.propTypes = {
  children: propTypes.oneOfType([propTypes.string, propTypes.array]).isRequired,
  variant: propTypes.oneOf(['primary', 'secondary', 'inverted', 'tertiary']),
  handleClick: propTypes.func,
  type: propTypes.string,
  disabled: propTypes.bool,
};

export default Button;
